<template lang="pug">
  .lei-info-label(:class="typeClass") {{text}}
</template>

<script>
export default {
  name: 'LeiInfoLabel',
  props: {
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => [
        'info',
        'warning',
        'error',
        'placeholder',
        'prerequisite',
      ].includes(value),
    },
  },
  computed: {
    typeClass () {
      return `lei-info-label_${this.type}`
    },
  },
}
</script>`

<style scoped lang="stylus">
  @import "../../assets/styles/variables.styl"

  .lei-info-label
    margin 10px 0
    padding 20px
    border-radius 2px
    font-weight 600
    line-height 25px

    &_info
      border 1px solid $info-color
      background $info-color-light
      color $info-color
    &_warning
      border 1px solid $warning-color
      background $warning-color-light-1
      color $warning-color
    &_prerequisite
      border 1px solid $warning-color
      background $warning-color-light-1
      color $warning-color
      margin 0
    &_error
      border 1px solid $danger-color
      background $danger-color-light-2
      color $danger-color
    &_placeholder
      border 1px solid $default-color-light-1
      background $default-color-light-2
      color $default-color
</style>



// WEBPACK FOOTER //
// src/components/lei-components/LeiInfoLabel.vue